import React from 'react';
import PropTypes from 'prop-types';
import Slave from './Slave';


const Wrapper = ({ master, showBeforeOrAfter, resourceName, onClickSchedule, masterData, lang, children }) => (master ?
  <div>
    {children}
  </div>
  :
  <Slave
    showBeforeOrAfter={showBeforeOrAfter}
    resourceName={resourceName}
    onClickSchedule={onClickSchedule}
    masterData={masterData}
    lang={lang}


  >

    {children}
  </Slave>
);

Wrapper.propTypes = {
  master: PropTypes.bool.isRequired,
  showBeforeOrAfter: PropTypes.bool.isRequired,
  resourceName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/Resource/components/Wrapper.jsx